import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { TableHead, Typography } from '@mui/material';
import { currencyFormat } from '../../../utils/number';
import { dateFormat } from '../../../utils/date';
import GenericTablePaginationActions from '../../../component/generic/GenericTablePaginationActions';

const columns = [
    { id: 'idPedido', label: 'ID do pedido', minWidth: 80, align: 'center' },
    { id: 'unidadeName', label: 'Unidade', minWidth: 150 },
    { id: 'nomeUsuario', label: 'Usuário', minWidth: 150 },
    { id: 'dataHoraEvento', label: 'Data', minWidth: 120, align: 'center' },
    { id: 'tipo', label: 'Tipo', minWidth: 80, align: 'center' },
    { id: 'entidade', label: 'Entidade', minWidth: 80, align: 'center' },
    { id: 'motivo', label: 'Motivo', minWidth: 200 },
    { id: 'valor', label: 'Valor', minWidth: 100, align: 'center' },
    { id: 'formaPagamento', label: 'Forma de pagamento', minWidth: 150 },
];

const SEM_VALOR = '---';

// Exclusão antiga pode não ter valor no log: melhor um traço do que "0,00", que
// seria lido como pagamento de valor zero.
function formatValor(valor) {
    if (valor === null || valor === undefined) {
        return SEM_VALOR;
    }

    return currencyFormat(valor, { simbol: '' });
}

export default function ListPaymentExclusion({ data }) {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - data?.length) : 0;

    const handleChangePage = (_, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <TableContainer elevation={0} component={Paper}>
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        {columns.map((column) => (
                            <TableCell
                                key={column.id}
                                align={column.align}
                                style={{ minWidth: column.minWidth }}
                            >
                                {column.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {(rowsPerPage > 0
                        ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        : data
                    ).map((row, index) => (
                        <TableRow key={index}>
                            <TableCell align="center">{row.idPedido || SEM_VALOR}</TableCell>
                            <TableCell align="left">{row.unidadeName}</TableCell>
                            <TableCell align="left">
                                {row.nomeUsuario || SEM_VALOR}
                                {row.usernameUsuario && (
                                    <Typography variant="body2" color="text.secondary">
                                        {row.usernameUsuario}
                                    </Typography>
                                )}
                            </TableCell>
                            <TableCell align="center">
                                {dateFormat(row.dataHoraEvento, { pattern: 'dd/MM/yyyy HH:mm:ss' })}
                            </TableCell>
                            <TableCell align="center">{row.tipo}</TableCell>
                            <TableCell align="center">{row.entidade}</TableCell>
                            <TableCell align="left">{row.motivo}</TableCell>
                            <TableCell align="center">{formatValor(row.valor)}</TableCell>
                            <TableCell align="left">{row.formaPagamento || SEM_VALOR}</TableCell>
                        </TableRow>
                    ))}
                    {emptyRows > 0 && (
                        <TableRow style={{ height: 53 * emptyRows }}>
                            <TableCell colSpan={columns.length} />
                        </TableRow>
                    )}
                </TableBody>

                <TableFooter>
                    <TableRow>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 50, { label: 'Todos', value: -1 }]}
                            colSpan={columns.length}
                            count={data?.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            labelRowsPerPage="linhas por página"
                            SelectProps={{
                                inputProps: {
                                    'aria-label': 'linhas por página',
                                },
                                native: true,
                            }}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            ActionsComponent={GenericTablePaginationActions}
                        />
                    </TableRow>
                </TableFooter>
            </Table>
        </TableContainer>
    );
}
